import Image from "next/image";

export default function AppLogo() {
  return (
    <Image
      alt="Oakwood Roofing & Sheet Metal Co Ltd — a CanPro company"
      style={{ width: "min(360px, calc(100vw - 5rem))", height: "auto" }}
      height={750}
      priority
      src="/oakwood-a-canpro-company.png"
      unoptimized
      width={2048}
    />
  );
}
